import { RotatingLines } from "react-loader-spinner";

export const  Loader=({ width = "96" })=> {
  return (
    <RotatingLines
      strokeColor="rgba(102, 100, 195, 0.66)"
      strokeWidth="5"
      animationDuration="0.75"
      width={width}
      visible={true}
    />
  )
}